import { render, staticRenderFns } from "./shipment-detail-b2b.vue?vue&type=template&id=71048969&scoped=true"
import script from "./shipment-detail-b2b.vue?vue&type=script&lang=js"
export * from "./shipment-detail-b2b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71048969",
  null
  
)

export default component.exports